"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoScoreLevel = exports.AutoQualityLevel = exports.SourceScoreLevel = exports.TranscodeScoreLevel = void 0;
var TranscodeScoreLevel;
(function (TranscodeScoreLevel) {
    TranscodeScoreLevel["Lowest"] = "transcode:lowest";
    TranscodeScoreLevel["Low"] = "transcode:low";
    TranscodeScoreLevel["MediumLow"] = "transcode:medium-low";
    TranscodeScoreLevel["Medium"] = "transcode:medium";
    TranscodeScoreLevel["MediumHigh"] = "transcode:medium-high";
    TranscodeScoreLevel["High"] = "transcode:high";
    TranscodeScoreLevel["Highest"] = "transcode:highest";
})(TranscodeScoreLevel || (exports.TranscodeScoreLevel = TranscodeScoreLevel = {}));
var SourceScoreLevel;
(function (SourceScoreLevel) {
    SourceScoreLevel["Low"] = "source:low";
    SourceScoreLevel["Medium"] = "source:medium";
    SourceScoreLevel["High"] = "source:high";
})(SourceScoreLevel || (exports.SourceScoreLevel = SourceScoreLevel = {}));
var AutoQualityLevel;
(function (AutoQualityLevel) {
    AutoQualityLevel["Auto"] = "auto-quality";
})(AutoQualityLevel || (exports.AutoQualityLevel = AutoQualityLevel = {}));
var AutoScoreLevel;
(function (AutoScoreLevel) {
    AutoScoreLevel["Default"] = "auto:default";
    AutoScoreLevel["Auto"] = "auto:auto";
})(AutoScoreLevel || (exports.AutoScoreLevel = AutoScoreLevel = {}));
//# sourceMappingURL=bitrate-switching.js.map